module.exports = __webpack_public_path__ + "img/IMG_9621_FoamcoreMatted.5d965027.jpg";